import { IAppAction } from "../appAction";

export const applicationActions = {
  TOGGLE_BURGER_MENU: "TOGGLE_BUTGER_MENU",
  TOGGLE_PROFILE_MENU: "TOGGLE_PROFILE_MENU",
  TOGGLE_SEARCH_BAR: "TOGGLE_SEARCH_BAR",
  HIDE_ALL_MENUS: "HIDE_ALL_MENUS",
  SET_SERVER_RESPONSE: "SET_SERVER_RESPONSE",
  SET_SERVER_ERROR: "SET_SERVER_ERROR",
  SET_GIF_QUALITY: "SET_GIF_QUALITY",
  TOGGLE_GIF_SOUND: "TOGGLE_GIF_SOUND",
  TOGGLE_FULLSCREEN: "TOGGLE_FULLSCREEN",
  TOGGLE_FORCE_FS: "TOGGLE_FORCE_FS"
};

export const toggleBurgerMenu = (): IAppAction => ({
  type: applicationActions.TOGGLE_BURGER_MENU
});

export const toggleProfileMenu = (): IAppAction => ({
  type: applicationActions.TOGGLE_PROFILE_MENU
});

export const toggleSearchBar = (): IAppAction => ({
  type: applicationActions.TOGGLE_SEARCH_BAR
});

export const setGifQuality = (gifQuality: string): IAppAction => ({
  type: applicationActions.SET_GIF_QUALITY,
  payload: gifQuality
});

export const toggleGifSound = (gifSound: boolean): IAppAction => ({
  type: applicationActions.TOGGLE_GIF_SOUND,
  payload: gifSound
});

export const hideAllMenus = (): IAppAction => ({
  type: applicationActions.HIDE_ALL_MENUS,
});

export const setServerResponse = (serverResponse: string | null): IAppAction => ({
  type: applicationActions.SET_SERVER_RESPONSE,
  payload: serverResponse
});

export const setServerError = (serverError: Error | null): IAppAction => ({
  type: applicationActions.SET_SERVER_ERROR,
  payload: serverError
});

export const toggleFullScreen = (payload: boolean): IAppAction => ({
  type: applicationActions.TOGGLE_FULLSCREEN,
  payload
});

export const toggleForceFS = (payload: boolean): IAppAction => ({
  type: applicationActions.TOGGLE_FORCE_FS,
  payload
});
